/**
 * BreadcrumbContext
 * Permite que las vistas de detalle (formularios que se abren como overlay y
 * no cambian la URL) añadan su nombre a la barra de ruta global.
 *
 * Las migas se guardan en una pila: si se abre un panel encima de otro, la
 * última en montarse es la que se muestra; al desmontarse se recupera la
 * anterior automáticamente.
 */

import { useSyncExternalStore } from 'react';

/** @type {{ id: symbol, label: string }[]} */
let entries = [];
const listeners = new Set();

function emitChange() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getDetailLabel() {
  return entries.length ? entries[entries.length - 1].label : null;
}

/** Registra (o actualiza) la miga de un registro abierto. */
export function registerDetailCrumb(id, label) {
  if (!label) {
    unregisterDetailCrumb(id);
    return;
  }
  const existing = entries.find((entry) => entry.id === id);
  if (existing?.label === label) return;
  entries = [...entries.filter((entry) => entry.id !== id), { id, label }];
  emitChange();
}

/** Quita la miga de un registro cuando se cierra su vista. */
export function unregisterDetailCrumb(id) {
  if (!entries.some((entry) => entry.id === id)) return;
  entries = entries.filter((entry) => entry.id !== id);
  emitChange();
}

/** Etiqueta del registro abierto actualmente (o null). */
export function useDetailCrumbLabel() {
  return useSyncExternalStore(subscribe, getDetailLabel, getDetailLabel);
}
